<div class="page">
  <lib-ph-bhp-header [appUrl]="appUrl" [userData]="config.userData" [institutions]="config.institutions" (childData)="childEmit($event)"></lib-ph-bhp-header>
  <div class="page-content d-flex align-items-stretch">
    <lib-ph-bhp-navbar [navData]="filterPackageData"></lib-ph-bhp-navbar>
    <router-outlet></router-outlet>
  </div>
</div>